module.exports = __webpack_public_path__ + "media/images/arkea-140646ac.png";